export default {
    activities:        { method: 'get',    url: 'activities' },
    createActivity:    { method: 'post',   url: 'activities'},
    updateActivity:    { method: 'put',    url: 'activities/{id}'},
    deleteActivity:    { method: 'delete', url: 'activities/{id}'}
}